import { assertNever } from '@omnea-app/packages/universal/type-guards/assertNever'
import type { DocumentResponse } from '@omnea-app/documents/documentsHttpClient'

export type RequestDocumentReviewStatus = NonNullable<
  NonNullable<DocumentResponse<'/request/{requestId}/documents', 'get'>['data']>[number]['reviewStatus']
>

export const isReviewInFlight = (status?: RequestDocumentReviewStatus): boolean => {
  switch (status) {
    case 'expected':
    case 'pending':
      return true
    case 'completed':
    case 'failed':
    case undefined:
      return false
    default:
      assertNever(status)
      return false
  }
}
